const setVariantInfoPopupState = (popup, shouldOpen) => {
  popup.hidden = !shouldOpen;
  document.querySelector(`[aria-controls="${popup.id}"]`)?.setAttribute('aria-expanded', shouldOpen.toString());
  popup.closest('.product-form__input')?.classList.toggle('variant-info-popup-open', shouldOpen);
  popup.closest('.product__variant')?.classList.toggle('variant-info-popup-open', shouldOpen);
};

const closeVariantInfoPopup = (popup) => setVariantInfoPopupState(popup, false);

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('.variant-info-popup__trigger');
  const currentPopup = trigger
    ? document.getElementById(trigger.getAttribute('aria-controls'))
    : event.target.closest('.variant-info-popup__content');

  document.querySelectorAll('.variant-info-popup__content:not([hidden])').forEach((popup) => {
    if (popup !== currentPopup) closeVariantInfoPopup(popup);
  });

  if (!trigger || !currentPopup) return;

  const shouldOpen = currentPopup.hidden;
  setVariantInfoPopupState(currentPopup, shouldOpen);
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  document.querySelectorAll('.variant-info-popup__content:not([hidden])').forEach((popup) => {
    const trigger = document.querySelector(`[aria-controls="${popup.id}"]`);
    closeVariantInfoPopup(popup);
    trigger?.focus();
  });
});